import { MessageKey, t } from "./i18n";

/**
 * Param name -> display-label i18n key. The English param name doubles as the
 * logic key (settableParams name, edge param, bulk-edit key), so only the
 * displayed label is localized here; names absent from this map render by their
 * bare name. Shared by the object panel, the group bulk rows, and the Param-in
 * dropdown so all three show the same localized name.
 */
export const PARAM_LABELS: Record<string, MessageKey> = {
  bounce: "param.bounce",
  friction: "param.friction",
  mass: "param.mass",
  pitch: "param.pitch",
  timbre: "param.timbre",
  mute: "param.mute",
  kill: "param.killOnHit",
  collision: "param.collisionOn",
  play: "param.play",
  value: "param.value",
  hue: "param.hue",
  sat: "param.sat",
  spread: "param.spread",
  speed: "param.speed",
  "spd range": "param.spdRange",
  life: "param.life",
  "life range": "param.lifeRange",
  drag: "param.drag",
  min: "param.min",
  max: "param.max",
  length: "param.length",
  gravity: "paramOpt.gravity",
  tempo: "paramOpt.tempo",
  simple: "paramOpt.simple",
  node: "paramOpt.node",
};

export function paramLabel(name: string): string {
  const key = PARAM_LABELS[name];
  return key !== undefined ? t(key) : name;
}
